<template>
  <div>
    <el-popover
      placement="right"
      trigger="hover"
    >
      <!-- <el-button slot="reference">content</el-button> -->
      <img slot="reference" class="w-full h-full inline-block" :src="joinHead(src)" alt="">
      <div>
        <img class="w-80 h-80" :src="joinHead(src)" alt="">
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
